export enum UserLevel {
    SiteEmployee = "Site Employee",
    SiteAdmin = "Site Admin",
    OrgEmployee = "Org Employee",
    OrgAdmin = "Org Admin",
    DealerEmployee = "Dealer Employee",
    DealerAdmin = "Dealer Admin",
    GlobalAdmin = "Global Admin"
}
